// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Form, Button, Alert } from "react-bootstrap";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import "./AdminCSS/operations.css";
// // import { API_URL } from "../../config/config"; // Adjust the path as needed

// const API_URL = process.env.REACT_APP_API_URL;


// const AddDevice = () => {
//   const [userId, setUserId] = useState("");
//   const [users, setUsers] = useState([]);
//   const [macAddress, setMacAddress] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate(); // Initialize navigate

//   // Fetch users when the component mounts
//   // useEffect(() => {
//   //   const fetchUsers = async () => {
//   //     try {
//   //       const response = await axios.get(`${API_URL}/users/users/`);
//   //       setUsers(response.data);
//   //     } catch (error) {
//   //       setMessage("Error fetching users");
//   //     }
//   //   };

//   //   fetchUsers();
//   // }, []);

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');

//     const response = await axios.post(
//       `${API_URL}/devices/addDevice/`,
//       {
//         user_id: parseInt(userId),
//         mac_address: macAddress,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       }
//     );

//     setMessage(`Device added successfully! ID: ${response.data.device_id}`); // Update to match your response structure
//     setUserId("");
//     setMacAddress("");
//   } catch (error) {
//     console.error(
//       "Error details:",
//       error.response ? error.response.data : error.message
//     );
//     if (error.response && error.response.status === 401) {
//       setMessage('Unauthorized: Please log in again.');
//       navigate('/login');
//     } else {
//       setMessage(error.response?.data?.detail || "Error adding device");
//     }
//   }
// };


//   const handleClose = () => {
//     navigate("/admindashboard"); // Replace with the correct route to the admin dashboard
//   };

//   return (
//     <div className="add-device-wrapper">
//       <div className="add-device-container">
//         <div className="header">
//           <h3>Add Device</h3>
//           <button className="close-button" onClick={handleClose}>
//             &times;
//           </button>
//         </div>
//         <Form onSubmit={handleSubmit}>
//           {/* <Form.Group>
//             <Form.Label>Select User:</Form.Label>
//             <Form.Control
//               as="select"
//               value={userId}
//               onChange={(e) => setUserId(e.target.value)}
//             >
//               <option value="">Select a user</option>
//               {users.map((user) => (
//                 <option key={user.user_id} value={user.user_id}>
//                   {user.user_name}
//                 </option>
//               ))}
//             </Form.Control>
//           </Form.Group> */}
//           <Form.Group>
//             <Form.Label>MAC Address:</Form.Label>
//             <Form.Control
//               type="text"
//               value={macAddress}
//               onChange={(e) => setMacAddress(e.target.value)}
//             />
//           </Form.Group>
//           <Button variant="primary" type="submit">
//             Add Device
//           </Button>
//         </Form>
//         {message && (
//           <Alert variant="info" className="mt-3">
//             {message}
//           </Alert>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddDevice;




import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AdminCSS/operations.css";

const API_URL = process.env.REACT_APP_API_URL;

const AddDevice = () => {
  const [macAddress, setMacAddress] = useState("");
  const [imeiNumber, setImeiNumber] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Require at least one field
    if (!macAddress && !imeiNumber) {
      setMessage("Provide either MAC address or IMEI number.");
      return;
    }

    try {
      const token =
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token");

      const response = await axios.post(
        `${API_URL}/devices/addDevice/`,
        {
          mac_address: macAddress || null,
          imei_number: imeiNumber || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setMessage(
        `Device added successfully! ID: ${response.data.device_id}`
      );

      setMacAddress("");
      setImeiNumber("");
    } catch (error) {
      console.error(
        "Error details:",
        error.response ? error.response.data : error.message
      );

      if (error.response && error.response.status === 401) {
        setMessage("Unauthorized: Please log in again.");
        navigate("/login");
      } else {
        setMessage(
          error.response?.data?.detail || "Error adding device"
        );
      }
    }
  };

  const handleClose = () => {
    navigate("/admindashboard");
  };

  return (
    <div className="add-device-wrapper">
      <div className="add-device-container">
        <div className="header">
          <h3>Add Device</h3>
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>MAC Address:</Form.Label>
            <Form.Control
              type="text"
              value={macAddress}
              onChange={(e) => setMacAddress(e.target.value)}
              placeholder="Enter MAC (optional)"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>IMEI Number:</Form.Label>
            <Form.Control
              type="text"
              value={imeiNumber}
              onChange={(e) => setImeiNumber(e.target.value)}
              placeholder="Enter 15-digit IMEI (optional)"
            />
          </Form.Group>

          <Button variant="primary" type="submit">
            Add Device
          </Button>
        </Form>

        {message && (
          <Alert variant="info" className="mt-3">
            {message}
          </Alert>
        )}
      </div>
    </div>
  );
};

export default AddDevice;